import { render, staticRenderFns } from "./VTaskList.vue?vue&type=template&id=7df1eb06&scoped=true"
import script from "./VTaskList.vue?vue&type=script&lang=ts"
export * from "./VTaskList.vue?vue&type=script&lang=ts"
import style0 from "./VTaskList.vue?vue&type=style&index=0&id=7df1eb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df1eb06",
  null
  
)

export default component.exports